/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { DomainState, DomainStore } from 'src/luis/types/stores/domains/DomainStore';

/**
 * A factory function for creating an domain store,
 * which have an array of domains.
 */
export const createDomainStore = (domain: Partial<DomainStore>): DomainStore => {
    const store: DomainStore = {
        id: '',
        name: domain.name,
        state: null,
        culture: domain.culture,
        tokenizerVersion: domain.tokenizerVersion,
        examples: domain.examples,
        description: domain.description,
        intents: domain.intents,
        entities: domain.entities,

        /**
         * Represents the state of whether a prebuilt domain is added
         * in the application, is not, or is currently being added/removed.
         */
        setDomainState(state: DomainState): void {
            this.state = state;
        }
    };

    return observable(
        store,
        {
            name: observable,
            culture: observable,
            tokenizerVersion: observable,
            examples: observable,
            description: observable,
            intents: observable,
            entities: observable,
            state: observable,
            setDomainState: action
        },
        { deep: false }
    );
};
